import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledTableWrapper = styled.div`
  overflow-x: auto;
  max-width: 100%;
`;

export const StyledTable = styled.table`
  border-bottom: 1px solid ${tvar('colors.table.border')};
  width: 100%;
  border-spacing: 0;
  margin-bottom: ${tvar('space.x2')};
`;

export const StyledTableHeaderRow = styled.tr``;

export const StyledTableHeaderCell = styled.th`
  font-weight: bold;
  text-align: left;
  padding: ${tvar('space.x1')};
  cursor: pointer;

  &:hover {
    background: ${tvar('colors.table.hover')};
  }

  svg {
    margin-left: ${tvar('space.x1')};
    color: ${tvar('colors.button.primary.fg')};
  }
`;

export const StyledInvisibleTableHeaderCell = styled.span`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const StyledTableRow = styled.tr`
  background: ${tvar('colors.table.background')};
  transition: background 0.2s ease-in-out;

  td {
    border-top: 1px solid ${tvar('colors.table.border')};
  }
  &:hover {
    background: ${tvar('colors.table.hover')};
  }
`;

export const StyledTableCell = styled.td`
  border: 0;
  padding: ${tvar('space.x1')};
`;
